<template>
  <div class="login-container">
    <img :src="'/img/Signup-Finish.png'" />
    <span class="title">Congratulations</span>
    <div class="login-content">
      <button @click="finish()" class="button-default big finish">
        <span>Go to Dashboard</span>
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { M_UPDATE_SIGNUP_FINISHED, M_UPDATE_SIGNUP_STEP } from "@/graphql";

export default {
  name: "SignupWizardStepFinished",
  async created() {
    await this.setStep(8);
  },
  computed: {
    ...mapState("signup", ["id"])
  },
  methods: {
    async setStep(step) {
      await this.$apollo.mutate({
        client: "localClient",
        mutation: M_UPDATE_SIGNUP_STEP,
        variables: {
          id: this.id,
          signup_step: step
        }
      });
    },
    async finish() {
      await this.$apollo.mutate({
        mutation: M_UPDATE_SIGNUP_FINISHED,
        variables: {
          id: this.id,
          signup_finished: true
        }
      });

      await this.$store.dispatch("setSignupFinished", true);
      this.$emit("finish");
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: 100%;
  /* BG/type2 */
  background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 300px;
  }
  .title {
    display: block;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .login-content {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    button.finish {
      width: 199px;
    }
  }
}
</style>
